import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { useSelector, useDispatch } from "react-redux";
import { fetchMasterList } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";

const UserDepartmentForm = (props) => {
  let deptList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.DEPARTMENT.name]?.data
  ); // User Details from Store

  const [validate, setValidate] = useState(false);
  const { t } = useTranslation();
  const formRef = useRef(null);
  const [statusConfirmModel, setStatusConfirmModel] = useState(false);
  let [deptCode, setDeptCode] = useState();
  let [deptName, setDeptName] = useState();
  const [error, setError] = useState(false);

  const dispatch = useDispatch();

  const handleSave = (event) => {
    if (!deptCode) {
      setError(true);
      return;
    }
    const form = formRef.current;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      const deptObj = {
        deptCode,
        deptName
      }
      let departments = props.user.departments ? props.user.departments : []
      departments = [...departments, deptObj]
      const user = { ...props.user, departments }
      event.preventDefault();
      event.stopPropagation();
      props.onSave(user);
      props.onHide();
    }
  };

  const handleDeptFormCancel = (event) => {
    setDeptCode("");
    setDeptName("");
    props.onHide();
  };

  useEffect(() => {
    if (!deptList) {
      dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deptList]);

  const deptResult =
    deptList &&
    deptList.map(({ deptCode, deptName }) => ({ deptCode, deptName: `${deptCode} - ${deptName}` }));

  const deptCodeList = props.user?.departments?.map((entry) => entry.deptCode);

  const filteredDepartments = deptResult?.filter(
    (department) => !deptCodeList?.includes(department?.deptCode)
  );

  const { show, onHide } = props;
  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        animation={false}
        backdrop="static"
        className="secondModal"
      >
        <ModalHeader
          title={t("msg_master_list.msg_department.page_title")}
        ></ModalHeader>
        <ModalBody>
          <Form noValidate validated={validate} ref={formRef}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="col-form-label">
                {" "}
                {t("msg_reports.msg_machine_idle_status.department")} :
              </Form.Label>
              <DropdownListField
                id="deptCode"
                name="deptName"
                className="dropdownHive w-full rounded-md"
                data={filteredDepartments}
                value={deptCode}
                onChange={(value) => { setDeptCode(value?.deptCode); setDeptName(value?.deptName); }}
                placeholder={t(
                  "msg_master_list.msg_machines.select_department"
                )}
                autoFocus={true}
                error={error}
                disabled={!filteredDepartments}
              />
            </Form.Group>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            variant="success"
            className="btn btn-success"
            onClick={handleSave}
          >
            {t("msg_common.save")}
          </Button>
          <Button
            type="button"
            variant="danger"
            className="btn btn-danger"
            onClick={handleDeptFormCancel}
            data-dismiss="modal"
          >
            {t("msg_common.cancel")}
          </Button>
        </ModalFooter>
      </Modal>

      {statusConfirmModel && (
        <ConfirmationModal
          show={statusConfirmModel}
          heading={t("msg_common.confirmation")}
          bodyMessage={t("msg_master_list.msg_process.status_change_message")}
          onOk={() => setStatusConfirmModel(false)}
          onHide={() => setStatusConfirmModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}
    </>
  );
};

export default UserDepartmentForm;
